import React, { useEffect, useState } from "react";
import CustomSwiper from "../../ui/Slider";
import SpecialistCard from "./SpecialistCard";
import TextSlider from "../../ui/TextSlider";
import { specializationOptions } from "../../../utils/constants";
import api from "../../../configs/api";
import Loader from "../../../common/Loader";

export default function Specialties() {
  const [categoriesFilter, setCategoriesFilter] = useState({
    value: "",
    label: "الكل",
  });
  const [specialists, setSpecialists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getSpecialists = async () => {
    try {
      const res = await api.get(
        `/specialist/get_specialists?specialization=${categoriesFilter?.value}`,
      );
      setSpecialists(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    getSpecialists();
  }, [categoriesFilter]);

  const handleChange = (item) => {
    setCategoriesFilter(item);
  };

  return (
    <section className='mt-[7rem] mb-10 select-none'>
      <div className='container mx-auto'>
        <div>
          <h2 className='text-custom-50 font-custom-900 text-center my-8'>
            التخصصات
          </h2>
          <div dir='rtl' className='mx-7 mb-7'>
            <TextSlider slidesPerView={6} isNavigation className='mx-14'>
              {specializationOptions.map((item, index) => (
                <div className='' key={item.name + index}>
                  <button
                    onClick={() => handleChange(item)}
                    className={`text-custom-18  ${
                      categoriesFilter.value === item.value
                        ? "text-primary3 font-custom-600"
                        : "text-[#b7b7b7] font-custom-600"
                    }`}
                  >
                    {item.label}
                  </button>
                </div>
              ))}
            </TextSlider>
          </div>
          {isLoading ? (
            <div className='flex justify-center items-center h-[27.1875rem]'>
              <Loader isFullScreen={false} />
            </div>
          ) : (
            <>
              {specialists.length ? (
                <CustomSwiper
                  freeMode={true}
                  slidesPerView={3}
                  spaceBetween={40}
                  grid={{
                    rows: 2,
                    fill: "row",
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    650: { slidesPerView: 2 },
                    800: { slidesPerView: 3 },
                  }}
                  isPagination={true}
                  isNavigation={true}
                >
                  {specialists.map((item, index) => (
                    <div className='mx-10' key={item.name + index}>
                      <SpecialistCard data={item} />
                    </div>
                  ))}
                </CustomSwiper>
              ) : (
                <div className='flex justify-center items-center text-custom-25 font-custom-900 h-[400px]'>
                  لا يوجد نتائج
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
